export type RangeHandle = { element: HTMLElement; set: (v: number) => void };

export function renderHeading(text: string): HTMLElement {
  const h = document.createElement("h2");
  h.textContent = text;
  return h;
}

export function rangeControl(
  label: string,
  initial: number,
  min: number,
  max: number,
  step: number,
  onChange: (v: number) => void,
  format: (v: number) => string = (v) => `${v}`,
): RangeHandle {
  const wrap = document.createElement("div");
  wrap.className = "control";
  const lab = document.createElement("label");
  const text = document.createElement("span");
  text.textContent = label;
  const val = document.createElement("span");
  val.className = "value";
  val.textContent = format(initial);
  lab.append(text, val);
  const input = document.createElement("input");
  input.type = "range";
  input.min = `${min}`;
  input.max = `${max}`;
  input.step = `${step}`;
  input.value = `${initial}`;
  input.addEventListener("input", () => {
    const v = Number.parseFloat(input.value);
    val.textContent = format(v);
    onChange(v);
  });
  wrap.append(lab, input);
  return {
    element: wrap,
    set: (v: number) => {
      input.value = `${v}`;
      val.textContent = format(v);
    },
  };
}

export type SelectHandle<T extends string> = { element: HTMLElement; set: (v: T) => void };

export function selectControl<T extends string>(
  label: string,
  initial: T,
  options: Array<[T, string]>,
  onChange: (v: T) => void,
): SelectHandle<T> {
  const wrap = document.createElement("div");
  wrap.className = "control";
  const lab = document.createElement("label");
  const text = document.createElement("span");
  text.textContent = label;
  lab.append(text);
  const sel = document.createElement("select");
  for (const [v, t] of options) {
    const opt = document.createElement("option");
    opt.value = v;
    opt.textContent = t;
    if (v === initial) opt.selected = true;
    sel.appendChild(opt);
  }
  sel.addEventListener("change", () => onChange(sel.value as T));
  wrap.append(lab, sel);
  return {
    element: wrap,
    set: (v: T) => { sel.value = v; },
  };
}
